console.log('🚀 Comparison Table JS: Loading...');

/**
 * Table Wrapper Killer Module
 * Removes theme.js table-wrapper divs that interfere with custom layout
 * Runs on multiple lifecycle hooks to catch wrapper injection
 */
window.ComparisonModules = window.ComparisonModules || {};

window.ComparisonModules.TableWrapperKiller = (function () {
  const WRAPPER_SEL = 'div.table-wrapper[data-scroll-lock-scrollable]';
  const SECTION_SELS = ['#comparison-section', '#comparison-section-hardcoded'];
  
  let observerInstance = null;
  let debounceTimeout = null;

  function unwrapAll() {
    let unwrapped = 0;
    
    SECTION_SELS.forEach(sectionSel => {
      const section = document.querySelector(sectionSel);
      if (!section) return;
      
      const wrappers = section.querySelectorAll(WRAPPER_SEL);
      wrappers.forEach(wrapper => {
        const table = wrapper.querySelector('table');
        
        // Only unwrap if wrapper contains exactly one child (the table)
        if (table && wrapper.children.length === 1 && wrapper.firstElementChild === table) {
          wrapper.replaceWith(table);
          unwrapped++;
          console.log('🔧 Unwrapped table:', table.className || table.id);
        }
      });
    });
    
    return unwrapped;
  }

  function start() {
    console.log('🚀 TableWrapperKiller: Starting...');
    
    // Run immediately
    const initial = unwrapAll();
    console.log(`✅ Initial unwrap: ${initial} tables`);

    // Shopify section lifecycle - when theme.js re-runs wrapElements()
    document.addEventListener('shopify:section:load', () => {
      console.log('📦 Section loaded, checking for wrappers...');
      unwrapAll();
    });
    
    document.addEventListener('shopify:section:reorder', () => {
      console.log('🔄 Section reordered, checking for wrappers...');
      unwrapAll();
    });

    // MutationObserver for late injection (debounced for performance)
    SECTION_SELS.forEach(sectionSel => {
      const section = document.querySelector(sectionSel);
      if (section) {
        observerInstance = new MutationObserver(() => {
          clearTimeout(debounceTimeout);
          debounceTimeout = setTimeout(() => {
            unwrapAll();
          }, 100);
        });
        
        observerInstance.observe(section, { 
          childList: true, 
          subtree: true 
        });
        console.log('👁️ MutationObserver attached to', sectionSel);
      }
    });

    return observerInstance;
  }

  return { start, unwrapAll };
})();

// Start the wrapper killer immediately
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.ComparisonModules.TableWrapperKiller.start();
  });
} else {
  window.ComparisonModules.TableWrapperKiller.start();
}

/**
 * Header Setup Module
 * Creates scrollable header wrapper and hides scrollbar
 */

window.ComparisonModules = window.ComparisonModules || {};

window.ComparisonModules.HeaderSetup = {
  init: function(stickyHeaders) {
    const headerTable = stickyHeaders.querySelector('.headers-table');
    
    if (!headerTable) {
      console.error('Header table not found');
      return null;
    }
    
    // Wrap header in scrollable container
    const headerWrapper = document.createElement('div');
    headerWrapper.style.overflowX = 'auto';
    headerWrapper.style.overflowY = 'hidden';
    headerWrapper.style.width = '100%';
    headerWrapper.style.scrollbarWidth = 'none'; // Firefox
    headerWrapper.style.msOverflowStyle = 'none'; // IE
    
    // Hide scrollbar with CSS
    const style = document.createElement('style');
    style.textContent = `
      .sticky-headers-container > div::-webkit-scrollbar {
        display: none;
      }
    `;
    document.head.appendChild(style);
    
    stickyHeaders.appendChild(headerWrapper);
    headerWrapper.appendChild(headerTable);
    
    return headerWrapper;
  }
};
/**
 * Progress Tracker Module
 * Tracks vertical scroll progress through the comparison section
 */

window.ComparisonModules = window.ComparisonModules || {};

window.ComparisonModules.ProgressTracker = {
  init: function(comparisonSection, progressBar, progressFill, scrollIndicator) {
    let sectionInView = false;
    
    function updateProgress() {
      const sectionRect = comparisonSection.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const sectionHeight = comparisonSection.offsetHeight;
      
      // Check if section is in view
      const inView = sectionRect.top < windowHeight && sectionRect.bottom > 0;
      
      if (inView !== sectionInView) {
        sectionInView = inView;
        
        if (inView) {
          progressBar.classList.add('visible');
          scrollIndicator.classList.add('visible');
        } else {
          progressBar.classList.remove('visible');
          scrollIndicator.classList.remove('visible');
        }
      }
      
      if (!inView) return;
      
      // Calculate scroll progress through the section
      const sectionTop = sectionRect.top;
      let progress = 0;
      
      if (sectionTop <= 0) {
        // Section top is above viewport
        const scrolledPast = -sectionTop;
        const totalScrollable = sectionHeight - windowHeight;
        progress = Math.min(100, (scrolledPast / totalScrollable) * 100);
      }
      
      progressFill.style.width = progress + '%';
      
      // Update indicator
      if (progress >= 95) {
        scrollIndicator.textContent = '✓ All features viewed - scroll to continue';
        setTimeout(() => {
          scrollIndicator.classList.remove('visible');
        }, 2000);
      } else {
        scrollIndicator.textContent = `Scroll to view all features (${Math.round(progress)}%)`;
      }
    }
    
    // Listen to main window scroll with RAF throttling
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateProgress();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    // Initial check
    updateProgress();
    
    // Return sectionInView getter for other modules
    return {
      isSectionInView: () => sectionInView
    };
  }
};
/**
 * Scroll Sync Module
 * Syncs horizontal scroll between header and content
 */

window.ComparisonModules = window.ComparisonModules || {};

window.ComparisonModules.ScrollSync = {
  init: function(comparisonContent, headerWrapper) {
    // Sync horizontal scroll: content -> header
    comparisonContent.addEventListener('scroll', function() {
      if (headerWrapper) {
        headerWrapper.scrollLeft = comparisonContent.scrollLeft;
      }
    });
    
    // Sync scroll from header to content
    headerWrapper.addEventListener('scroll', function() {
      comparisonContent.scrollLeft = headerWrapper.scrollLeft;
    });
  }
};
/**
 * Mobile Scroll Sync Module
 * Syncs horizontal scroll between mobile header and content on mobile
 * Handles both drag and swipe momentum, prevents infinite loops
 */

window.ComparisonModules = window.ComparisonModules || {};

window.ComparisonModules.MobileScrollSync = {
  init: function(comparisonContent, mobileHeaders) {
    if (!comparisonContent || !mobileHeaders) {
      console.error('Missing elements for mobile scroll sync');
      return;
    }
    
    // Enable scroll snap on both elements
    comparisonContent.style.scrollSnapType = 'x mandatory';
    mobileHeaders.style.scrollSnapType = 'x mandatory';
    
    let isContentActive = false;
    let isHeaderActive = false;
    let isSyncingToHeader = false;
    let isSyncingToContent = false;
    let scrollEndTimeout;
    let currentTouchId = 0;
    let contentTouchId = 0;
    let headerTouchId = 0;
    let lastContentScroll = 0;
    let lastHeaderScroll = 0;
    let idleCheckInterval = null;
    
    // Start checking for idle state
    function startIdleCheck() {
      if (idleCheckInterval) return; // Already running
      
      idleCheckInterval = setInterval(() => {
        const contentIdle = comparisonContent.scrollLeft === lastContentScroll;
        const headerIdle = mobileHeaders.scrollLeft === lastHeaderScroll;
        
        if (contentIdle && headerIdle && !isContentActive && !isHeaderActive) {
          // Both stopped, sync if misaligned
          if (comparisonContent.scrollLeft !== mobileHeaders.scrollLeft) {
            mobileHeaders.scrollLeft = comparisonContent.scrollLeft;
          }
          // Stop checking once synced and idle
          clearInterval(idleCheckInterval);
          idleCheckInterval = null;
        }
        
        lastContentScroll = comparisonContent.scrollLeft;
        lastHeaderScroll = mobileHeaders.scrollLeft;
      }, 100);
    }
    
    // Track touch state on content
    comparisonContent.addEventListener('touchstart', function() {
      currentTouchId++;
      contentTouchId = currentTouchId;
      clearTimeout(scrollEndTimeout);
      isContentActive = true;
      isHeaderActive = false;
      // Sync positions immediately on touch
      mobileHeaders.scrollLeft = comparisonContent.scrollLeft;
      // Ensure snap is on content (being touched), off on header (being synced)
      comparisonContent.style.scrollSnapType = 'x mandatory';
      mobileHeaders.style.scrollSnapType = 'none';
      // Start idle checking for when scrolling ends
      startIdleCheck();
    }, { passive: true });
    
    comparisonContent.addEventListener('touchend', function() {
      // Don't immediately deactivate - let scroll momentum finish
      scrollEndTimeout = setTimeout(() => {
        isContentActive = false;
        mobileHeaders.style.scrollSnapType = 'x mandatory';
      }, 150);
    }, { passive: true });
    
    comparisonContent.addEventListener('touchcancel', function() {
      scrollEndTimeout = setTimeout(() => {
        isContentActive = false;
        mobileHeaders.style.scrollSnapType = 'x mandatory';
      }, 150);
    }, { passive: true });
    
    // Track touch state on header
    mobileHeaders.addEventListener('touchstart', function() {
      currentTouchId++;
      headerTouchId = currentTouchId;
      clearTimeout(scrollEndTimeout);
      isHeaderActive = true;
      isContentActive = false;
      // Sync positions immediately on touch
      comparisonContent.scrollLeft = mobileHeaders.scrollLeft;
      // Ensure snap is on header (being touched), off on content (being synced)
      mobileHeaders.style.scrollSnapType = 'x mandatory';
      comparisonContent.style.scrollSnapType = 'none';
      // Start idle checking for when scrolling ends
      startIdleCheck();
    }, { passive: true });
    
    mobileHeaders.addEventListener('touchend', function() {
      // Don't immediately deactivate - let scroll momentum finish
      scrollEndTimeout = setTimeout(() => {
        isHeaderActive = false;
        comparisonContent.style.scrollSnapType = 'x mandatory';
      }, 150);
    }, { passive: true });
    
    mobileHeaders.addEventListener('touchcancel', function() {
      scrollEndTimeout = setTimeout(() => {
        isHeaderActive = false;
        comparisonContent.style.scrollSnapType = 'x mandatory';
      }, 150);
    }, { passive: true });
    
    // Sync content scroll to header
    comparisonContent.addEventListener('scroll', function() {
      const myTouchId = contentTouchId;
      if (isContentActive && myTouchId === currentTouchId && !isSyncingToContent) {
        isSyncingToHeader = true;
        mobileHeaders.scrollLeft = comparisonContent.scrollLeft;
        isSyncingToHeader = false;
      }
    }, { passive: true });
    
    // Sync header scroll to content
    mobileHeaders.addEventListener('scroll', function() {
      const myTouchId = headerTouchId;
      if (isHeaderActive && myTouchId === currentTouchId && !isSyncingToHeader) {
        isSyncingToContent = true;
        comparisonContent.scrollLeft = mobileHeaders.scrollLeft;
        isSyncingToContent = false;
      }
    }, { passive: true });
    
    console.log('✅ Mobile scroll sync initialized (touch-end aware sync)');
  }
};
/**
 * Drag to Scroll Module
 * Enables click-and-drag scrolling on content and header areas
 */

window.ComparisonModules = window.ComparisonModules || {};

window.ComparisonModules.DragToScroll = {
  init: function(comparisonContent, headerWrapper) {
    console.log('🖱️ DragToScroll: Initializing');
    
    if (!comparisonContent) {
      console.error('❌ comparisonContent not found!');
      return;
    }
    
    console.log('🎯 Setting up drag on comparison-content');
    
    let isDragging = false;
    let startX;
    let scrollLeft;
    
    comparisonContent.addEventListener('mousedown', function(e) {
      isDragging = true;
      comparisonContent.style.cursor = 'grabbing';
      comparisonContent.style.userSelect = 'none';
      
      startX = e.pageX - comparisonContent.offsetLeft;
      scrollLeft = comparisonContent.scrollLeft;
    });
    
    comparisonContent.addEventListener('mouseleave', function() {
      isDragging = false;
      comparisonContent.style.cursor = 'grab';
    });
    
    comparisonContent.addEventListener('mouseup', function() {
      isDragging = false;
      comparisonContent.style.cursor = 'grab';
    });
    
    comparisonContent.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      e.preventDefault();
      
      const x = e.pageX - comparisonContent.offsetLeft;
      const walk = (x - startX) * 2;
      comparisonContent.scrollLeft = scrollLeft - walk;
    });
    
    comparisonContent.style.cursor = 'grab';
    console.log('✅ DragToScroll: Content initialized');
    
    // DRAG TO SCROLL - Header
    if (headerWrapper) {
      let isDraggingHeader = false;
      let startXHeader;
      let scrollLeftHeader;
      
      headerWrapper.addEventListener('mousedown', function(e) {
        isDraggingHeader = true;
        headerWrapper.style.cursor = 'grabbing';
        headerWrapper.style.userSelect = 'none';
        
        startXHeader = e.pageX - headerWrapper.offsetLeft;
        scrollLeftHeader = headerWrapper.scrollLeft;
      });
      
      headerWrapper.addEventListener('mouseleave', function() {
        isDraggingHeader = false;
        headerWrapper.style.cursor = 'grab';
      });
      
      headerWrapper.addEventListener('mouseup', function() {
        isDraggingHeader = false;
        headerWrapper.style.cursor = 'grab';
      });
      
      headerWrapper.addEventListener('mousemove', function(e) {
        if (!isDraggingHeader) return;
        e.preventDefault();
        
        const x = e.pageX - headerWrapper.offsetLeft;
        const walk = (x - startXHeader) * 2;
        headerWrapper.scrollLeft = scrollLeftHeader - walk;
      });
      
      headerWrapper.style.cursor = 'grab';
      console.log('✅ DragToScroll: Header initialized');
    }
  }
};
/**
 * Keyboard Navigation Module
 * Arrow key navigation for horizontal scrolling
 */

window.ComparisonModules = window.ComparisonModules || {};

window.ComparisonModules.KeyboardNav = {
  init: function(comparisonContent, getSectionInView) {
    document.addEventListener('keydown', function(e) {
      if (!getSectionInView()) return;
      
      const scrollAmount = 100;
      
      switch(e.key) {
        case 'ArrowRight':
          e.preventDefault();
          comparisonContent.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          break;
        case 'ArrowLeft':
          e.preventDefault();
          comparisonContent.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
          break;
      }
    });
  }
};
/**
 * Specs Toggle Module
 * Show/hide collapsible specification rows
 */

window.ComparisonModules = window.ComparisonModules || {};

window.ComparisonModules.SpecsToggle = {
  init: function() {
    const specsToggleBtn = document.getElementById('specs-toggle');
    const collapsibleRows = document.querySelectorAll('.collapsible-row');
    let isCollapsed = true; // Start collapsed
    
    if (!specsToggleBtn) return;
    
    specsToggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      isCollapsed = !isCollapsed;
      
      const icon = specsToggleBtn.querySelector('.toggle-icon');
      const text = specsToggleBtn.querySelector('.toggle-text');
      
      if (isCollapsed) {
        // Hide extra specs
        collapsibleRows.forEach(row => row.classList.add('hidden'));
        icon.textContent = '+';
        text.textContent = 'Show more specs';
      } else {
        // Show all specs
        collapsibleRows.forEach(row => row.classList.remove('hidden'));
        icon.textContent = '−';
        text.textContent = 'Show less specs';
      }
    });
  }
};
/**
 * V5: Comparison Table - Main Controller
 * Loads and initializes all modules
 */

console.log('📦 Modules loaded:', window.ComparisonModules ? Object.keys(window.ComparisonModules) : 'NONE');

document.addEventListener('DOMContentLoaded', function() {
  console.log('✅ DOM Ready - Starting initialization');
  
  const BREAKPOINT_MOBILE = 768;
  const isMobile = window.innerWidth <= BREAKPOINT_MOBILE;
  
  console.log(`📐 Screen: ${window.innerWidth}px - ${isMobile ? 'MOBILE' : 'DESKTOP'} mode`);
  
  if (isMobile) {
    // MOBILE - Full initialization
    console.log('📱 Mobile - Initializing modules');
    
    const comparisonContent = document.getElementById('comparison-content');
    const mobileHeaders = document.getElementById('mobile-headers');
    
    // Mobile scroll sync
    window.ComparisonModules.MobileScrollSync.init(comparisonContent, mobileHeaders);
    
    // Specs toggle
    window.ComparisonModules.SpecsToggle.init();
    
    console.log('✅ Mobile modules initialized: TableWrapperKiller (auto-started), MobileScrollSync, SpecsToggle');
    return;
  }
  
  // DESKTOP ONLY - Full initialization
  console.log('🖥️ Desktop - Initializing all modules');
  
  const comparisonContent = document.getElementById('comparison-content');
  const stickyHeaders = document.getElementById('sticky-headers');
  const comparisonSection = document.getElementById('comparison-section');
  const progressBar = document.querySelector('.scroll-progress-bar');
  const progressFill = document.getElementById('progress-fill');
  const scrollIndicator = document.getElementById('scroll-indicator');
  
  console.log('📋 Elements:', { 
    content: !!comparisonContent, 
    headers: !!stickyHeaders,
    section: !!comparisonSection,
    progressBar: !!progressBar
  });
  
  // Initialize Header Setup to create wrapper
  const headerWrapper = window.ComparisonModules.HeaderSetup.init(stickyHeaders);
  
  // Initialize Progress Tracker
  const progressTracker = window.ComparisonModules.ProgressTracker.init(
    comparisonSection, 
    progressBar, 
    progressFill, 
    scrollIndicator
  );
  
  // Initialize Scroll Sync between header and content
  window.ComparisonModules.ScrollSync.init(comparisonContent, headerWrapper);
  
  // Initialize Drag to Scroll with header wrapper
  window.ComparisonModules.DragToScroll.init(comparisonContent, headerWrapper);
  
  // Initialize Keyboard Navigation
  window.ComparisonModules.KeyboardNav.init(comparisonContent, progressTracker.isSectionInView);
  
  // Initialize Specs Toggle
  window.ComparisonModules.SpecsToggle.init();
  
  console.log('✅ All modules initialized: TableWrapperKiller (auto-started), HeaderSetup, ProgressTracker, ScrollSync, DragToScroll, KeyboardNav, SpecsToggle');
});
